import React, { ReactNode } from 'react';
import cn from 'classnames';

import s from './index.module.less';

const ModuleContainer = ({
  contentWidth, title, suTitle, id, children, className,
}: {
  contentWidth: number, title: string, suTitle?: string, id: string, children: ReactNode, className?: string,
}) => (
  <div className={cn(s.container, className)} id={id}>
    <div className={s.title}>{title}</div>
    {
      suTitle && <div className={s.subTitle}>{suTitle}</div>
    }
    <div className={s.content} style={{ width: contentWidth }}>{children}</div>
  </div>
);

export default ModuleContainer;
